import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AutoManagedJoinedInfluencers.graphql';
import { Query, QueryautoManagedJoinedInfluencersArgs } from '../../__generated__/globalTypes';

export const useAutoManagedJoinedInfluencersQuery = (
  options?: QueryHookOptions<Query, QueryautoManagedJoinedInfluencersArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryautoManagedJoinedInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAutoManagedJoinedInfluencersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryautoManagedJoinedInfluencersArgs>
): QueryResult<Query, QueryautoManagedJoinedInfluencersArgs> & {
  getAutoManagedJoinedInfluencers: LazyQueryExecFunction<Query, QueryautoManagedJoinedInfluencersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAutoManagedJoinedInfluencers, result] = useLazyQuery<Query, QueryautoManagedJoinedInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAutoManagedJoinedInfluencers, ...result };
};

export const useAutoManagedJoinedInfluencersPromiseQuery = () => {
  const client = useApolloClient();

  const getAutoManagedJoinedInfluencers = useCallback(
    (options?: Omit<QueryOptions<QueryautoManagedJoinedInfluencersArgs, Query>, 'query'>) =>
      client.query<Query, QueryautoManagedJoinedInfluencersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAutoManagedJoinedInfluencers };
};
// Suspense Query Hooks
export const useAutoManagedJoinedInfluencersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryautoManagedJoinedInfluencersArgs>
) => {
  const result = useSuspenseQuery<Query, QueryautoManagedJoinedInfluencersArgs>(QUERY, {
    ...options
  });

  return result;
};
